import type { DataUpload } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type UpdateDataUploadSuccessResponse = DataUpload;

export async function updateDataUpload(
	id: string,
	dataUpload: Omit<DataUpload, 'id'>,
): Promise<UpdateDataUploadSuccessResponse | null> {
	const response = await axios.patch(`${API_URLS.DATA_UPLOAD.INDEX}/${id}`, dataUpload);
	return getResponse<UpdateDataUploadSuccessResponse>(response.data);
}
